import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SectionProps } from '../utils/SectionProps';
import SectionHeader from '../components/sections/partials/SectionHeader';
import Button from '../components/elements/Button';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const CURRENT_PLUGIN_VERSION = 'v1.0.0';
const CURRENT_PLUGIN_FILE = '/downloads/exanta-analytics-1.0.0.zip';

const pluginDownloads = [
  {
    version: CURRENT_PLUGIN_VERSION,
    file: CURRENT_PLUGIN_FILE
  }
];

const Download = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor
}) => {
  const outerClasses = classNames(
    'signin section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'signin-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const downloadTileClasses = classNames(
    'tiles-item',
    'download-tiles-item'
  );

  const sectionHeader = {
    title: 'Download the Exanta WooCommerce plugin',
    paragraph: 'Download the latest plugin zip below, or choose an older version from the release table.'
  };

  return (
    <section className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader tag="h1" data={sectionHeader} className="center-content" />
          <div className="tiles-wrap">
            <div className={downloadTileClasses}>
              <div className="tiles-item-inner has-shadow">
                <p className="mt-0 mb-24 center-content">
                  <a href={CURRENT_PLUGIN_FILE} className="func-link h4">
                    Download the Exanta WooCommerce Plugin Zip file
                  </a>
                </p>
                <div className="mb-24">
                  <table>
                    <thead>
                      <tr>
                        <th>Version</th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pluginDownloads.map((download) => (
                        <tr key={download.version}>
                          <td>{download.version}</td>
                          <td>
                            <a href={download.file} className="func-link">
                              {download.file.replace('/', '')}
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Button tag={Link} to="/account" color="primary" wide>
                  Back to Account
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Download.propTypes = propTypes;
Download.defaultProps = defaultProps;

export default Download;
